import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import {
  BASE_URL,
  DOCUMENT_DOWNLOAD,
  DOCUMENT_FETCH,
  DOCUMENT_CREATE,
  DOCUMENT_UPDATE,
  DOCUMENT_DELETE,
  M_POST
} from '@/utils/api';

@Module({ name: 'document' })
export default class DocumentUrl extends VuexModule {
  dataFile: any = {};

  documentApi: any = [];

  @Mutation
  mutateDocumentFile(payload: any) {
    this.dataFile = payload;
  }

  @Mutation
  mutateDocumentApi(payload: any) {
    this.documentApi = payload;
  }

  @Action({ commit: 'mutateDocumentFile', rawError: true })
  async DownloadDocument(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + DOCUMENT_DOWNLOAD,
        responseType: 'blob',
        data: params,
        method: M_POST
      });

      return { dataFile: data };
    } catch (err: any) {
      throw toError(err, 'Download document failed');
    }
  }

  @Action({ commit: 'mutateDocumentApi', rawError: true })
  async FetchDocumentApi(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + DOCUMENT_FETCH,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch document api failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch document api failed');
    }
  }

  @Action({ rawError: true })
  async CreateDocumentApi(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + DOCUMENT_CREATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Create document api failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Create document api failed');
    }
  }

  @Action({ rawError: true })
  async UpdateDocumentApi(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + DOCUMENT_UPDATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update document api failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Update document api failed');
    }
  }

  @Action({ rawError: true })
  async DeleteDocumentApi(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + DOCUMENT_DELETE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Delete document api failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Delete document api failed');
    }
  }
}
